import React, { useEffect, useState } from "react";
import { Col, Form, FormFeedback, FormGroup, Input, Label } from "reactstrap";
import HelpTooltip from "../help-tooltip";
import { t } from "../../../utils/utils";

export default function NodeNameValidation({
  nodesNames,
  onSubmit,
  oldName,
  label,
  feedback,
  inputProps
}) {
  const [invalid, setInvalid] = useState(false);
  const [name, setName] = useState("");
  useEffect(() => {
    if (oldName) {
      setName(oldName);
    }
  }, [oldName]);
  const validName = () => {
    const nodesName = oldName
      ? nodesNames.filter(o => o !== oldName)
      : nodesNames;
    setInvalid(nodesName.includes(name));
  };
  return (
    <>
      <Form
        id="formPropertyBar"
        onSubmit={e => {
          e.preventDefault();
          if (!invalid) onSubmit(name);
        }}
      >
        <FormGroup row>
          <Col xs="12">
            <Label for="name">{t(label)}</Label>{" "}
            <HelpTooltip msg={t("modalPropiedadesTooltipValidacionNombre")} />
          </Col>
          <Col sm={4} xs={10}>
            <Input
              name="node"
              id="name"
              placeholder={t("modalPropiedadesPlaceholderValidacionNombre")}
              value={name}
              invalid={invalid}
              required
              onChange={e => setName(e.target.value.trim())}
              onBlur={validName}
              {...inputProps}
            />
            <FormFeedback>{t(feedback)}</FormFeedback>
          </Col>
        </FormGroup>
      </Form>
    </>
  );
}
